import CloseButton from "@/components/buttons/CloseButton";
import { DefaultPrimaryButton, InformationModal } from "@/styles/globalstyles";
import { Modal, Box, TextField, Typography, Button, Divider } from "@mui/material";
import { useState } from "react";
import type { createGroupParams } from "@/api/groupService";
import { useCreateGroup } from "@/hooks/groupHook";
import { toSnakeCase } from "@/utils/healper";
import { useQueryHandler } from "@/hooks/useQueryHandler";
import { getAxiosErrorMessage } from "@/utils/healper";

interface SaveRoleModalProps {
  open: boolean;
  handleClose: () => void;
}

const SaveRoleModal = ({ open, handleClose }: SaveRoleModalProps) => {
  const [formData, setFormData] = useState<createGroupParams>({
    group_key: "",
    display_name: "",
    description: "",
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const { mutate: createGroup, isSuccess: createGroupIsSuccess, isPending: creatingGroup, isError: createGroupIsError, error: createGroupError } = useCreateGroup();

  useQueryHandler({
    isError: createGroupIsError,
    error: createGroupError,
    isFetching: creatingGroup,
    isSuccess: createGroupIsSuccess,
    errorMessage: getAxiosErrorMessage(createGroupError),
    successMessage: "เพิ่มบทบาทสำเร็จ",
  });

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!formData.display_name) {
        newErrors.display_name = "กรุณากรอกชื่อบทบาท";
    }

    if (!formData.description) {
        newErrors.description = "กรุณากรอกคำอธิบาย";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  const handleSaveRole = () => {
    if (!validateForm()) return;
    createGroup({
      ...formData
    });
    handleClose();
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...InformationModal, maxHeight: "90vh" }}>
        <CloseButton onClick={handleClose} />
        <Typography variant="h2">เพิ่มบทบาทใหม่</Typography>
        <Box p={1}>
          <Divider sx={{ my: 1 }} />
          <TextField
            fullWidth
            label={
              <>
                ชื่อบทบาท{" "}
                <Typography component="span" color="error.main">
                  *
                </Typography>
              </>
            }
            variant="outlined"
            sx={{ mt: 2 }}
            value={formData.display_name}
            error={!!errors.display_name}
            helperText={errors.display_name}
            onChange={(e) => {
              setFormData({ ...formData, display_name: e.target.value, group_key: toSnakeCase(e.target.value) });
              if (errors.display_name) {
                setErrors({ ...errors, display_name: "" });
              }
            }}
          />
          <TextField
            fullWidth
            label={
              <>
                คำอธิบาย{" "}
                <Typography component="span" color="error.main">
                  *
                </Typography>
              </>
            }
            variant="outlined"
            sx={{ mt: 2 }}
            value={formData.description}
            error={!!errors.description}
            helperText={errors.description}
            onChange={(e) => {
              setFormData({ ...formData, description: e.target.value });
              if (errors.description) {
                setErrors({ ...errors, description: "" });
              }
            }}
          />
        </Box>
        <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="contained" sx={DefaultPrimaryButton} onClick={handleSaveRole}>
            บันทึก
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SaveRoleModal;
